import { render, staticRenderFns } from "./OpenPositions.vue?vue&type=template&id=639809dc&scoped=true"
import script from "./OpenPositions.vue?vue&type=script&lang=js"
export * from "./OpenPositions.vue?vue&type=script&lang=js"
import style0 from "./OpenPositions.vue?vue&type=style&index=0&id=639809dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639809dc",
  null
  
)

export default component.exports